import React from "react";

import { Hero, LogoCloud, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";

function Clients() {
  const logos = [
    { src: "Assets/Clients/Ministry of Health.png", alt: "Ministry of Health" },
    { src: "Assets/Clients/Clinton_Health_Access_Initiative.png", alt: "Clinton Health Access Initiative" },
    { src: "Assets/Clients/ALIDZIWA-WEB-LOGO.png", alt: "ALIDZIWA" },
    { src: "Assets/Clients/BMP.png", alt: "BMP" },
    { src: "Assets/Clients/MEGA-LOGO.png", alt: "MEGA" },
    { src: "Assets/Clients/maranatha-logo.png", alt: "Maranatha" },
    { src: "Assets/Clients/comfweb.png", alt: "comfwb" },
    { src: "Assets/Clients/hiwa.webp", alt: "Hiwa" },
    { src: "Assets/Clients/ICTAM.png", alt: "ICTAM" },
    { src: "Assets/Clients/Lake Malawi Anglican Univ.png", alt: "Lake Malawi Anglican University" },
    { src: "Assets/Clients/Speed Fitment.jpg", alt: "Speed Fitment" },
    { src: "Assets/Clients/Atsikana Pa Ulendo.png", alt: "Atsikana Pa Ulendo" },
  ];

  return (
    <div>
      <Seo
        title="Clients"
        description="A selection of organizations that have trusted EasyBooks Solutions for software delivery, automation, and operational improvements."
      />
      <Hero
        eyebrow="Clients"
        title="Trusted by organizations that care about execution."
        subtitle="We work closely with teams to deliver systems that are usable, secure, and aligned to real workflows."
        primaryCta={{ label: "Work with us", to: "/Contact" }}
        secondaryCta={{ label: "Explore products", to: "/EasyBooks_Accounting" }}
        imageSrc="Assets/Clients/clients.jpg"
        imageAlt="EasyBooks clients"
        highlights={["Healthcare", "Government", "Education", "SMEs", "NGOs"]}
      />

      <LogoCloud title="Some of the teams we’ve supported" logos={logos} />

      <CTASection
        title="Want to see a relevant demo?"
        subtitle="Tell us your industry and team size we’ll tailor a walkthrough to your needs."
        primaryCta={{ label: "Request a demo", to: "/Contact" }}
        secondaryCta={{ label: "See success stories", to: "/SuccessStories" }}
      />
    </div>
  );
}

export default Clients;